import { IconChevronRight } from '@tvg/fuse-icons';
import PropTypes from 'prop-types';
import React from 'react';
import { PlainIconButton } from '../../fuse-buttons/src/buttons';
import { StyledButtonContainer, StyledNextButton } from './styled-buttons';

const defaultProps = {
	showButton: false,
};

const propTypes = {
	showButton: PropTypes.bool,
};

function NextButton({ showButton, ...props }) {
	return (
		<StyledNextButton className={!showButton && 'hidden'}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="6.1rem"
				height="100%"
				viewBox="0 0 61 44"
				fill="none"
			>
				<rect fill="url(#paint0_linear_next)" y="0" height="100%" x="0" width="100%" />
				<defs>
					<linearGradient
						id="paint0_linear_next"
						gradientUnits="userSpaceOnUse"
						x1="0%"
						x2="80%"
						y1="0"
						y2="0"
					>
						<stop offset="0" stopColor="var(--color-global-grey100)" stopOpacity="0" />
						<stop offset="0.9" stopColor="var(--color-global-grey200)" stopOpacity="1" />
					</linearGradient>
				</defs>
				<line
					x1="100%"
					y1="10"
					x2="100%"
					y2="34"
					stroke="var(--color-global-grey400)"
					strokeWidth="1px"
				/>
			</svg>
			<StyledButtonContainer
				className="fuse-tabs__next-button-icon-container"
				data-testid="fuse-tabs-next-button-icon-container-test-id"
			>
				<PlainIconButton
					className="fuse-tabs__next-button-icon"
					data-testid="fuse-tabs-next-button-icon-test-id"
					icon={<IconChevronRight />}
					size="medium"
					srLabel="Show next tabs"
					{...props}
				/>
			</StyledButtonContainer>
		</StyledNextButton>
	);
}

NextButton.propTypes = propTypes;
NextButton.defaultProps = defaultProps;

export default NextButton;
